import React, { memo } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Box, Dialog, Flex } from 'pcln-design-system'
import { CurrencySelectorDropdown } from '@pcln/selectors'
import SmallNavigation from '../SmallNavigation'
import NavHeader from '../NavHeader'
import { alignmentTypes, stringOrNumber, headerNavigationShape } from '../../utils/shapes'

const StyledDialog = styled(Dialog)`
  width: 100% !important;
  height: 100% !important;
  max-width: 100% !important;
  max-height: 100% !important;
`

const DialogContent = styled(Flex)`
  flex-direction: column;

  ${(props) =>
    props.showNavLinkBorders
      ? `
    & a {
      border-top: 1px solid lightgray;
    }

    & > * {
      border-bottom: 1px solid lightgray;
    }
    `
      : ''}
`
DialogContent.displayName = 'DialogContent'

function HeaderDialog({
  appName,
  currencies,
  currencyAcceptedApps,
  dropdownColor,
  hasNavigation,
  height,
  iconColor,
  initialCurrency,
  isMenuButtonRightAligned,
  isOpen,
  logoAlignment,
  logoHref,
  logoPath,
  logoTitle,
  menuBackgroundColor,
  menuColor,
  menuHeaderColor,
  navigation,
  phoneNumber,
  onClose,
  onCurrencyChange,
  secondaryLogoHref,
  secondaryLogoPadding,
  secondaryLogoPath,
  secondaryLogoTitle,
  showNavLinkBorders = true,
  target,
  ...props
}) {
  return (
    <StyledDialog open={isOpen} size='full' showCloseButton={false} onClose={onClose}>
      <NavHeader
        backgroundColor={menuBackgroundColor}
        color={menuHeaderColor}
        hasNavigation={hasNavigation}
        height={height}
        isMenuButtonRightAligned={isMenuButtonRightAligned}
        isOpen
        logoAlignment={logoAlignment}
        logoHref={logoHref}
        logoPath={logoPath}
        logoTitle={logoTitle}
        phoneNumber={phoneNumber}
        secondaryLogoHref={secondaryLogoHref}
        secondaryLogoPadding={secondaryLogoPadding}
        secondaryLogoPath={secondaryLogoPath}
        secondaryLogoTitle={secondaryLogoTitle}
        target={target}
        onClick={onClose}
      />
      <DialogContent showNavLinkBorders={showNavLinkBorders}>
        <SmallNavigation
          {...props}
          color={menuColor}
          iconColor={iconColor}
          dropdownColor={dropdownColor}
          navigation={navigation}
          target={target}
        />
        {currencyAcceptedApps?.includes(appName) && currencies && (
          <Box data-testid='mobile-currency' pt={2}>
            <CurrencySelectorDropdown
              currencies={currencies}
              onChange={onCurrencyChange}
              initialCurrency={initialCurrency}
            />
          </Box>
        )}
      </DialogContent>
    </StyledDialog>
  )
}

HeaderDialog.displayName = 'HeaderDialog'

HeaderDialog.propTypes = {
  appName: PropTypes.string,
  currencies: PropTypes.array,
  currencyAcceptedApps: PropTypes.arrayOf(PropTypes.string),
  dropdownColor: PropTypes.string,
  hasNavigation: PropTypes.bool,
  height: stringOrNumber,
  iconColor: PropTypes.string,
  initialCurrency: PropTypes.string,
  isMenuButtonRightAligned: PropTypes.bool,
  isOpen: PropTypes.bool,
  logoAlignment: alignmentTypes,
  logoHref: PropTypes.string,
  logoPath: PropTypes.string,
  logoTitle: PropTypes.string,
  menuBackgroundColor: PropTypes.string,
  menuColor: PropTypes.string,
  menuHeaderColor: PropTypes.string,
  navigation: PropTypes.arrayOf(headerNavigationShape),
  onClose: PropTypes.func,
  onCurrencyChange: PropTypes.func,
  phoneNumber: PropTypes.string,
  secondaryLogoHref: PropTypes.string,
  secondaryLogoPadding: PropTypes.number,
  secondaryLogoPath: PropTypes.string,
  secondaryLogoTitle: PropTypes.string,
  showNavLinkBorders: PropTypes.bool,
  target: PropTypes.string,
}

export default memo(HeaderDialog)
